import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export default makeStyles(() =>
  createStyles({
    search: {
      width: '100%',
      maxWidth: '600px',
    },
    popper: {
      minWidth: '400px',
      zIndex: 100,
    },
    searchIcon: {
      padding: 5,
      marginRight: 10,
      marginTop: 2,
    },
    container: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }),
);
